// URL search params and path ids for the checklist screens (constitution §5.6: filters persist in
// the URL). Anything that is not a valid value is dropped, so a hand-edited URL opens a sane page.
import { CHECKLIST_RUN_STATUSES } from '@cis/api-client';
import type { RunListSearch } from './checklist-page.tsx';

const MAX_PAGE = 10_000;
// A database id as the API accepts it in a path. Matches "1", "42"; rejects "0", "01", "1e3", "-1".
// https://regex101.com/?flavor=javascript&regex=%5E%5B1-9%5D%5Cd%7B0%2C14%7D%24&testString=1%0A42%0A0%0A01%0A1e3%0A-1
const RUN_ID = /^[1-9]\d{0,14}$/;

export function validateRunListSearch(search: Record<string, unknown>): RunListSearch {
  const page = Number(search['page']);
  const status = CHECKLIST_RUN_STATUSES.find((s) => s === search['status']);
  return {
    ...(Number.isInteger(page) && page > 1 && page <= MAX_PAGE ? { page } : {}),
    ...(status === undefined ? {} : { status }),
  };
}

export function runIdOf(raw: string): number | undefined {
  return RUN_ID.test(raw) ? Number(raw) : undefined;
}
